import axios from "axios";
import { CREATE_RESOUCE_FROM_CSV_ROUTE } from "./apiRoutes";

const createResourceFromCSV = (data, onProgress) => {
  const formData = new FormData();
  formData.append("user_slug", data.user_slug);
  formData.append("file", data.file);

  return axios.post(CREATE_RESOUCE_FROM_CSV_ROUTE, formData, {
    onUploadProgress: (progressEvent) => {
      if (onProgress) {
        const percent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgress(percent);
      }
    },
  });
};

export default createResourceFromCSV;
